<template>
    <div class="progress-page">
        <div class="rightDetail-step">
            <div class="reserve_box">
                <div class="minipro">
                    <div class="stepList">
                        <p class="num active_num">1</p>
                        <p class="name active_name">预约告知</p>
                        <img src="@/assets/progress.png" class="img">
                    </div>
                    <div class="stepList">
                        <p class="num active_num">2</p>
                        <p class="name active_name">预约申请</p>
                        <img src="@/assets/progress1.png" class="img">
                    </div>
                    <div class="stepList">
                        <p class="num">3</p>
                        <p class="name">预约安排</p>
                        <img src="@/assets/progress1.png" class="img">
                    </div>
                    <div class="stepList">
                        <p class="num">4</p>
                        <p class="name">预约完成</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="box margin-bottom-sm">
                <h4 class="box-title">
                    <div class="box-title-con">
                        <i style="background: rgb(0, 93, 204);"></i>
                        <span>预约权益</span>
                    </div>
                </h4>
                <div class="box-select flex flex-column-center flex-between" @click="show = true">
                    <p>{{ privilegeName }}</p>
                    <van-icon name="arrow-down" />
                </div>
                <van-action-sheet
                    v-model="show"
                    title="请选择预约的权益"
                    safe-area-inset-bottom
                >
                <div class="content-radio">
                    <van-radio-group v-model="privilegeId">
                        <van-cell-group>
                            <!-- privilegeList -->
                            <van-cell v-for="(item, index) in privilegeList" :key="index" :title="item.privilegeName + '  可用' + item.surplusCount+'次'" clickable @click="privilegeId = item.privilegeId+''">
                                <template #right-icon>
                                    <van-radio :name='`${item.privilegeId}`'>
                                        <template #icon="props">
                                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </van-radio>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
                <div class="text-center padding-confirm">
                    <van-button type="info" round block @click="onHandleSelectRights">确定</van-button>
                </div>
                </van-action-sheet>
                <div class="box-explain">
                    *当前权益剩余 {{ surplusCount >= 0 ? surplusCount : '无限' }} 次
                </div>
            </div>
            <div class="box margin-bottom-sm">
                <h4 class="box-title">
                    <div class="box-title-con">
                        <i style="background: rgb(0, 93, 204);"></i>
                        <span>权益人信息</span>
                    </div>
                </h4>
                <van-form>
                    <!-- <van-field
                        v-model="personName"
                        error
                        required
                        readonly
                        name="姓名"
                        label="姓名"
                        placeholder="用户名"
                        :rules="[{ required: true, message: '请填写用户名' }]"
                    /> -->

                    <van-cell-group required>
                        <van-field required readonly v-model="personName" label="姓名"/>
                    </van-cell-group>
                    <van-cell-group required>
                        <van-field required readonly v-model="cardType" label="证件类型" />
                    </van-cell-group>
                    <van-cell-group required>
                        <van-field required readonly v-model="credentialsNumber" label="证件号码" placeholder="请输入用户名" />
                    </van-cell-group>
                    
                    <!-- <van-cell title="性别" :value="sex" @click="showPicker = true" is-link /> -->
                    <van-cell-group required>
                        <van-field required readonly v-model="sex" label="性别" />
                    </van-cell-group>
                    <van-cell-group required>
                        <van-field required readonly v-model="birthday" label="出生日期" />
                    </van-cell-group>
                    <!-- 姓别 -->
                    <!-- <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="columns"
                            @confirm="onConfirm"
                            @cancel="showPicker = false"
                        />
                    </van-popup>
                    <van-cell required title="出生日期" :value="birthday" @click="showBirthday = true" is-link /> -->
                   
                    <!-- 出生日期 -->
                    <!-- <van-popup v-model="showBirthday" position="bottom">
                        <van-datetime-picker
                            v-model="currentDate"
                            type="date"
                            title="选择年月日"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="onBirthdaySelect"
                            @cancel="showBirthday = false"
                        />
                    </van-popup> -->
                    <van-cell-group required>
                        <van-field required :readonly="phoneFlag" v-model="personPhone" label="手机号" placeholder="请输入手机号" />
                    </van-cell-group>
                    
                    <van-cell required title="陪同人数"  v-if="privilegeType == 10"  :value="personCount" @click="showPersonCount = true" is-link />
                    <van-popup v-model="showPersonCount" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="columnsPersonCount"
                            @confirm="onConfirmPersonCount"
                            @cancel="showPersonCount = false"
                        />
                    </van-popup>
                    <van-cell required title="出发地" v-if="privilegeType == 10" :value="cityFromValue" @click="cityFrom = true" is-link />
                    <!-- 城市选择 -->
                    <van-popup
                        v-model="cityFrom"
                        round
                        position="bottom"
                        :style="{ height: '50%' }"
                    >
                        <van-area
                            title="请选择您的出发城市"
                            :area-list="areaList"
                            :value="regionCodeFrom"
                            @confirm="onSelectCityFrom"
                            @cancel="onCancleSelectCity"
                        />
                    </van-popup>
                    <van-cell-group required v-if="privilegeType == 10">
                        <van-field required v-model="addressFrom" label="详细地址" />
                    </van-cell-group>
                     <van-cell required title="目的地" v-if="privilegeType == 10" :value="cityToValue" @click="cityTo = true" is-link />
                    <!-- 城市选择 -->
                    <van-popup
                        v-model="cityTo"
                        round
                        position="bottom"
                        :style="{ height: '50%' }"
                    >
                        <van-area
                            title="请选择您的目的城市"
                            :area-list="areaList"
                            :value="regionCodeTo"
                            @confirm="onSelectCityTo"
                            @cancel="onCancleSelectCity"
                        />
                    </van-popup>
                    <van-cell-group required v-if="privilegeType == 10">
                        <van-field required v-model="addressTo" label="详细地址" />
                    </van-cell-group>
                </van-form>
            </div>
            <div class="box margin-bottom-sm" v-if="privilegeType == 5 || privilegeType == 4 || privilegeType == 7 || privilegeType == 8 || privilegeType == 9 || privilegeType == 6">
                <h4 class="box-title">
                    <div class="box-title-con">
                        <i style="background: rgb(0, 93, 204);"></i>
                        <span>就诊信息</span>
                    </div>
                </h4>
                <van-form>
                    <van-cell required title="所在城市" v-if="privilegeType == 4 || privilegeType == 7 || privilegeType == 8 || privilegeType == 9 || privilegeType == 6" :value="cityValue" @click="cityVisible = true" is-link />
                    <!-- 城市选择 -->
                    <van-popup
                        v-model="cityVisible"
                        round
                        position="bottom"
                        :style="{ height: '50%' }"
                    >
                        <van-area
                            title="请选择您的所在城市"
                            :area-list="areaList"
                            :value="regionCode"
                            @confirm="onSelectCity"
                            @cancel="onCancleSelectCity"
                        />
                    </van-popup>
                    <van-cell-group required v-if="privilegeType == 5 || privilegeType == 4 || privilegeType == 7 || privilegeType == 8 || privilegeType == 9 || privilegeType == 6">
                        <van-cell required title="医院名称" :value="hospital" @click="showPicker = true" is-link />
                        <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                            title="医院名称"
                            show-toolbar
                            :columns="hospitalList"
                            @confirm="onConfirm"
                            @cancel="showPicker = false"
                        />
                        </van-popup>
                    </van-cell-group>
                    <van-cell-group required v-if="privilegeType == 4 || privilegeType == 8 || privilegeType == 9">
                        <van-field required v-model="department" label="科室" />
                    </van-cell-group>
                    <van-cell-group required v-if="privilegeType == 8 || privilegeType == 9">
                        <van-field required v-model="doctorName" label="医生姓名" />
                    </van-cell-group>
                    <van-cell-group required v-if="privilegeType == 7">
                        <van-field required v-model="checkItem" label="检查项目" />
                    </van-cell-group>
                    <van-cell v-if="privilegeType != 5" required title="预约开始时间" :value="docDate" @click="showDocDate = true" is-link />
                   
                    <van-calendar 
                        v-model="showDocDate" 
                        @confirm="onBirthdaySelect"
                        color="#12cd9f"
                        :show-confirm="false"
                        :style="{ height: '600px' }"
                        first-day-of-week="1"
                        title="预约时间选择"
                        type="single"
                        :formatter="formatter"
                        />
                    <van-cell v-if="privilegeType != 5 && privilegeType != 6" required title="预约结束时间" :value="docDateEnd" @click="showDocDateEnd = true" is-link />
                    
                    <van-cell-group>
                        <van-field
                            class="desc"
                            required
                            v-model="applyDesc"
                            rows="2"
                            label="需求描述 / 病情描述"
                            type="textarea"
                            placeholder="输入详细的病情描述，当前用药及治疗方案、和您的需求等 "
                        />
                    </van-cell-group>
                </van-form>
            </div>
            <div class="box margin-bottom-sm">
                <h4 class="box-title">
                    <div class="box-title-con">
                        <i style="background: rgb(0, 93, 204);"></i>
                        <span>医学证明材料</span>
                    </div>
                </h4>
                <div v-if="privilegeType == 7">
                    <p class="error-tips">检查单</p>
                    <p class="pd-left">
                        <van-uploader
                            :max-count="9"
                            name="checkItemArray"
                            color="#12cd9f"
                            v-model="checkItemList"
                            :before-delete="beforeDelete"
                            :after-read="afterRead"
                            upload-text="点击上传"
                        />
                    </p>
                </div>
                <div v-if="privilegeType == 8 || privilegeType == 9">
                    <p class="error-tips">住院单</p>
                    <p class="pd-left">
                        <van-uploader
                            :max-count="9"
                            name="hospitalizedArray"
                            color="#12cd9f"
                            v-model="hospitalizedList"
                            :before-delete="beforeDelete"
                            :after-read="afterRead"
                            upload-text="点击上传"
                        />
                    </p>
                </div>
                <div>
                    <p class="error-tips">既往门/急诊及住院病历</p>
                    <p class="pd-left">
                        <van-uploader
                            :max-count="9"
                            name="caseListArray"
                            color="#12cd9f"
                            v-model="caseList"
                            :before-delete="beforeDelete"
                            :after-read="afterRead"
                            upload-text="点击上传"
                        />
                    </p>
                </div>

                <div>
                    <p class="error-tips">诊断报告</p>
                    <p class="pd-left">
                        <van-uploader
                            :max-count="9"
                            name="diagnosticReportArray"
                            v-model="diagnosticReport"
                            :before-delete="beforeDelete"
                            :after-read="afterRead"
                            upload-text="点击上传"
                        />
                    </p>
                </div>
                <div class="pd-none">
                    <p class="error-tips">其他</p>
                    <p class="pd-left">
                        <van-uploader
                            :max-count="9"
                            name="otherListArray"
                            v-model="otherList"
                            :before-delete="beforeDelete"
                            :after-read="afterRead"
                            upload-text="点击上传"
                        />
                    </p>
                </div>
                
            </div>
        </div>
        <div class="progress-page_footer fixed">
            <div class="btn-options">
                <van-button type="info" style="background-color: #12cd9f;" :disabled="btnDisabled" round block @click="goPage">下一步</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
moment().format();
const cardTypeFilter = {
    1: '身份证',
    2: '护照',
    3: '港澳内地通行证',
    4: '台胞证'
}
const sexFilter = {
    0: '男',
    1: '女'
}
import { areaList } from '@vant/area-data';
import { onFetchRightsUsedInfo, onUploadImage } from '@/api';
import { ImagePreview, Toast } from 'vant';
export default {
    data() {
        return {
            activeIcon: require('@/assets/checked.png'),
            inactiveIcon: require('@/assets/check-none.png'),
            show: false,
            areaList,
            cityVisible: false, // city flag
            cityFrom: false,
            cityTo: false,
            showBirthday: false, // birthday flag
            minDate: new Date(1940, 0, 1),
            maxDate: new Date(2099, 11, 31),
            currentDate: new Date(),
            showDocDate: false, // 就诊时间 
            showDocDateEnd: false,
            docDate: null, // 就诊时间 
            docDateEnd: null,
            minDocDate: new Date(),
            maxDocDate: moment(new Date()).add(1, 'y')._d,
            birthday: '', // 出生日期
            hospital: '',//医院名称
            checkItem: '',//检查项目
            personName: '', // 就诊人
            showPersonCount: false,
            department: '',//科室
            doctorName:'',//医生姓名
            addressFrom:'',//出发地
            addressTo: '',//目的地
            credentialsNumber: '', // 身份证号
            cardType: '',
            phoneFlag: true, // 是否可以输入手机号
            personPhone: '', // 手机号
            privielgeImgUrl: '', // 权益图片
            privilegeName: '---- 点击选择要使用的权益 ----', // 权益名
            privilegeId: '',
            surplusCount: 0, // 权益剩余次数
            credentialsFrontUrl: [], // 身份证正面
            credentialsFrontUrlArray: [], // 身份证正面传的值
            credentialsBackUrl: [], // 身份证反面
            credentialsBackUrlArray: [], // 身份证反面传过去的值
            hospitalList: ["北京协和医院","四川大学华西医院","上海瑞金医院","中山大学附属第一医院"],//可选医院
            height: "",
            weight: "",
            personCount: "",
            applyDate: "",
            applyDateEnd: "",
            applyDesc: "",
            regionCode: "",
            regionCodeFrom: "",
            regionCodeTo: "",
            cityValue: '', // 所在城市
            cityFromValue: '',
            cityToValue:'',
            caseList: [],
            checkItemList:[],
            diagnosticReport: [],
            otherList: [],
            hospitalizedList:[],
            caseListArray: [],
            checkItemArray:[],//检查单
            hospitalizedArray:[],//住院单
            diagnosticReportArray: [],
            otherListArray: [],
            username: '',
            sex: '',
            columns: ['男','女'],
            columnsPersonCount: ['0','1','2'],
            showPicker: false,
            btnDisabled: false, // 是否可以点击下一步
            uploader1: [],
            uploader2: [],
            uploader3: [],
            uploader4: [],
            uploader5: [],
            uploader6: [],
            uploader7: [],
            uploader8: [],
            uploader9: [],
            privilegeList: [], // 权益列表
            privilegeType: 4,
            holidayArray: ['2023-9-29','2023-9-30','2023-10-1','2023-10-2','2023-10-3','2023-10-4','2023-10-5','2023-10-6'],
        }
    },
    created() {
        this.privilegeId = localStorage.getItem('privilegeId');
        this.personId = localStorage.getItem('personId');
        this.init();
    },
    methods: {
        // 选择权益
        onHandleSelectRights() {
            this.onSelectRights();
            this.regionCode = '';
            this.hospital = '';
            this.department = '';
            this.doctorName = '';
            this.checkItem = '';
            this.docDate = '';
            this.docDateEnd = '';
            this.applyDate = '';
            this.applyDesc = '';
            this.applyDateEnd = '';
            this.cityValue = '';
            this.show = false;
        },
        // 选择权益
        onSelectRights() {
            console.log('this.privilegeList', this.privilegeList)
            console.log('this.privilegeId', this.privilegeId)
            this.privilegeList.forEach(v => {
                if (v.privilegeId == this.privilegeId) {
                    this.privielgeImgUrl = v.privielgeImgUrl;
                    this.privilegeName = v.privilegeName;
                    this.surplusCount = v.surplusCount;
                    this.privilegeType = v.privilegeType;
                }
            })
        },
        async init() {
            try {
                let params = {
                    privilegeId: this.privilegeId
                }

                if (this.personId) {
                    Object.assign(params, {
                        personId: this.personId
                    })
                }
                const res = await onFetchRightsUsedInfo(params);
                if(res.code == 200) {
                    console.log('res', res);
                    const { data } = res;
                    this.personName = data.personName;
                    this.privilegeList = data.privilegeList;
                    this.credentialsNumber = data.credentialsNumber;
                    this.cardType = cardTypeFilter[data.credentialsType];

                    this.sex = sexFilter[data.sexInt];
                    this.birthday = data.birthday;
                    this.personPhone = data.personPhone;
                    this.phoneFlag = this.personPhone ? true: false;
                    this.regionCode = data.regionCode;
                    // 选择权益
                    this.onSelectRights();
                    // res.data.privilegeList.forEach(v => {
                    //     if (v.privilegeId == this.privilegeId) {
                    //         this.privielgeImgUrl = v.privielgeImgUrl;
                    //         this.privilegeName = v.privilegeName;
                    //     }
                    // })
                }
            } catch(err) {
                console.log('err', err);
            }
        },
        // 选择城市
        onSelectCity(list) {
            console.log('list', list);
            this.cityVisible = false;

            this.cityValue = '';
            list.forEach(v => {
                this.cityValue += v.name;
            });
            console.log('list[list.length - 1]', list[list.length - 1])
            this.regionCode = list.reverse()[0].code;
        },
        // 选择城市
        onSelectCityFrom(list) {
            console.log('list', list);
            this.cityFrom = false;

            this.cityFromValue = '';
            list.forEach(v => {
                this.cityFromValue += v.name;
            });
            this.regionCodeFrom = list.reverse()[0].code;
        },
        // 选择城市
        onSelectCityTo(list) {
            console.log('list', list);
            this.cityTo = false;

            this.cityToValue = '';
            list.forEach(v => {
                this.cityToValue += v.name;
            });
            this.regionCodeTo = list.reverse()[0].code;
        },
        // 取消选择城市
        onCancleSelectCity() {
            this.cityVisible = false;
            this.cityFrom = false;
            this.cityTo = false;
        }, 
        // 选择生日
        onBirthdaySelect(date) {
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            this.docDate = `${year}-${month}-${day}`;
            this.applyDate = this.docDate;
            this.showDocDate = false;

            var afterDay = null;
            //计算结束时间
            if(this.privilegeType == 4){
                afterDay = this.addDateWeek(date, 6);
            }else if(this.privilegeType == 7){
                afterDay = this.addDateWeek(date, 2);
            }else if(this.privilegeType == 8 || this.privilegeType == 9){
                afterDay = this.addDateWeek(date, 9);
            }else if(this.privilegeType == 6){
                afterDay = this.docDate;
            }
            

            this.docDateEnd = afterDay;
            this.applyDateEnd = this.docDateEnd;
        },
        // 身份证预览
        previewImg(type) {
            const imageJson = {
                1: require('@/assets/idCard-front.png'),
                2: require('@/assets/idCard-back.png')
            }
            ImagePreview([imageJson[type]]);
        },
        beforeDelete(file, name) {
            console.log('before delete', name);
            this[name.name] = [];
        },
        // 上传
        async afterRead(file, obj) {
            const { name } = obj;
            // 此时可以自行将文件上传至服务器
            console.log('name', name);
            console.log('file', file)
            try {
                const res = await onUploadImage({
                    file: file.file
                });
                console.log('res', res);
                if(res.code == 200) {
                    const listType = ['caseListArray', 'diagnosticReportArray', 'otherListArray', 'hospitalizedArray','checkItemArray'];
                    console.log('listType.includes(name)', listType.includes(name))
                    
                    if (listType.includes(name)) {
                        this[`${name}`].push(res.data.imgUrl);
                    } else {
                        this[`${name}`] = res.data.imgUrl;
                    }
                    console.log('this', this);
                }
            } catch(err) {
                console.log('err', err);
            }

        },
        // 性别
        onConfirm(value) {
            this.hospital = value;
            this.showPicker = false;
        },
        onConfirmPersonCount(value) {
            this.personCount = value;
            this.showPersonCount = false;
        },
        
        onHandleChange() {
            this.btnDisabled = false;
        },
        goPage() {
             let params = {
                personName: this.personName,
                privielgeImgUrl: this.privielgeImgUrl,
                privilegeName: this.privilegeName,
                privilegeId: this.privilegeId,
                applyDate: this.applyDate,
                applyDateEnd: this.applyDateEnd,
                applyDesc: this.applyDesc,
                phone: this.personPhone,
                regionCode: this.regionCode,
                caseList: this.caseListArray,
                diagnosticReport: this.diagnosticReportArray,
                otherList: this.otherListArray,
                hospital: this.hospital,
                checkItem: this.checkItem,
                checkItemArray: this.checkItemArray,
                department: this.department,
                doctorName: this.doctorName,
                addressFrom: this.addressFrom,
                addressTo: this.addressTo,
                regionCodeFrom: this.regionCodeFrom,
                regionCodeTo: this.regionCodeTo,
                hospitalizedArray: this.hospitalizedArray,
                personCount: this.personCount
            }
            if (this.personId) {
                Object.assign(params, {
                    personId: this.personId
                })
            }
            console.log(this.privilegeName);
            if(this.privilegeName == "---- 点击选择要使用的权益 ----"){
                Toast('请选择要使用的权限');
                return false;
            }
            if (this.caseListArray.length == 0) {
                Toast('请上传既往门/急诊及住院病历');
                return false;
            }
            if (this.diagnosticReportArray.length == 0) {
                Toast('请上传诊断报告');
                return false;
            }
            if(this.privilegeType == 5){
                if (!this.hospital) {
                    Toast('请选择医院名称');
                    return false;
                }
                if (!this.applyDesc) {
                    Toast('请填写病情描述');
                    return false;
                }
            }

            if(this.privilegeType == 4 || this.privilegeType == 7 || this.privilegeType == 8 || this.privilegeType == 9 || this.privilegeType == 6) {
                if (!this.regionCode) {
                    Toast('请选择所在城市');
                    return false;
                }
                if (!this.hospital) {
                    Toast('请选择医院名称');
                    return false;
                }
                if(this.privilegeType == 7){
                    if (!this.checkItem) {
                        Toast('请填写检查项目');
                        return false;
                    }
                    if (this.checkItemArray.length == 0) {
                        Toast('请上传检查单照片');
                        return false;
                    }
                }
                if(this.privilegeType == 4){
                    if (!this.department) {
                        Toast('请填写科室名称');
                        return false;
                    }
                }
                if(this.privilegeType == 8 || this.privilegeType == 9){
                    if (!this.department) {
                        Toast('请填写科室名称');
                        return false;
                    }
                    if (!this.doctorName) {
                        Toast('请填写医生姓名');
                        return false;
                    }
                    if (this.hospitalizedArray.length == 0) {
                        Toast('请上传住院单照片');
                        return false;
                    }
                }
                if (!this.applyDate) {
                    Toast('请选择预约开始时间');
                    return false;
                }
                if (!this.applyDateEnd) {
                    Toast('请选择预约结束时间');
                    return false;
                }
                let date1 = new Date(this.applyDate);
                let date2 = new Date(this.applyDateEnd);
                if(date1.getTime() > date2.getTime()){
                    Toast('预约开始时间不能大于预约结束时间');
                    return false;
                }
                if (!this.applyDesc) {
                    Toast('请填写病情描述');
                    return false;
                }
            }
            if(this.privilegeType == 10) {
                if (!this.regionCodeFrom) {
                    Toast('请选择出发地城市');
                    return false;
                }
                if (!this.addressFrom) {
                    Toast('请输入出发地详情地址');
                    return false;
                }
                if (!this.regionCodeTo) {
                    Toast('请选择目的地城市');
                    return false;
                }
                if (!this.addressTo) {
                    Toast('请输入目的地详情地址');
                    return false;
                }
                if (!this.personCount) {
                    Toast('请选择陪同人数');
                    return false;
                }
            }


            localStorage.setItem('info', JSON.stringify(params));
            this.$router.push('/progressStep3');
        },
        formatter(day) {
            //3是周二
            let week = day.date.getDay() + 1;
            let year = day.date.getFullYear();
            let month = day.date.getMonth() + 1;
            let dayNow = day.date.getDate();
            let formatDay = `${year}-${month}-${dayNow}`;
            let weekArray = [];
            var now = new Date();
            var weekNow = now.getDay() + 1;
            var afterDay = '';
            
            //如果等于周一
            if(weekNow == 2){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //如果等于周二
            if(weekNow == 3){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //如果等于周三
            if(weekNow == 4){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //等于周四
            if(weekNow == 5){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //等于周五
            if(weekNow == 6){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //等于周六
            if(weekNow == 7){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            //等于周日
            if(weekNow == 1){
                weekArray.push(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate());
            }
            let date1 = new Date(formatDay);
            let date2 = new Date(afterDay);
            if(week == 7 || week == 1 || this.holidayArray.includes(formatDay) || weekArray.includes(formatDay) || date1.getTime() > date2.getTime()){
                day.type = 'disabled'
            }

            return day
        },
        addDate(date, days) {
            if (days == undefined || days == '') {
                days = 1;
            }
            var date = new Date(date);
            if(days != 0){
                date.setDate(date.getDate() + days);
            }
            var month = date.getMonth() + 1; //月份从0开始所以需要+1
            var day = date.getDate();
            return date.getFullYear() + '-' + month + '-' + day;
        },
        addDateWeek(date, days) {
            if (days == undefined || days == '') {
                days = 1;
            }
            var date = new Date(date);
            var i = 0;
            var result = 0;
            for(; i < days; ){
                date.setDate(date.getDate() + 1);
                var weekNow = date.getDay() + 1;
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let dayNow = date.getDate();
                let formatDay = `${year}-${month}-${dayNow}`;
                if(weekNow != 7 && weekNow != 1 && !this.holidayArray.includes(formatDay)){
                    i++;
                }
            }
            var month = date.getMonth() + 1; //月份从0开始所以需要+1
            var day = date.getDate();
            return date.getFullYear() + '-' + month + '-' + day;
        },
    }
}
</script>
<style scoped lang="less">
.content-radio {
    max-height: 400px;
    overflow-y: auto;
    .van-cell__title {
        text-align: center;
    }
    .img-icon {
        width: 20px;
    }
}
.padding-confirm {
    padding: 10px 20px;
}
.desc {
    letter-spacing: 1px;
}
.personal-height {
    padding: 0;
}
.progress-page {
    padding: 0 20px 70px;
    .minipro {
        display: flex;
        margin: 20px auto;
    }
    .stepList{
        flex:1;
        position:relative;

        .num {
            width: 30px;
            height: 30px;
            font-size: 16px;
            font-weight:500;
            text-align:center;
            line-height: 30px;
            margin:0 auto;
            background:#fff;
            border-radius:50%;
            color:#ccc;
            border:1px solid #ccc;
            &.active_num{
                background:#12cd9f;
                border-radius:50%;
                color:#fff;
            }
        }
        .active_num{
            background:#12cd9f;
            border-radius:50%;
            color:#fff;
        }
        .name{
            color:#ccc;
            font-size: 12px;
            font-weight: 500;
            margin-top: 7px;
            text-align: center;
            line-height: 18px;
            &.active_name {
                color:#12cd9f;
            }
        }
        .img{
            width: 12px;
            position:absolute;
            right:-6px;
            top: 10px;
        }
    }
    &_footer {
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        z-index: 9;
        font-size: 14px;
        .explian {
            justify-content: space-between;
            height: 60px;
            line-height: 60px;
            padding: 0 20px;
        }
        .btn-options {
            padding: 10px 20px;
            border-top: 1px solid #f4f4f4;
        }
    }
}

.pd-left {
    padding: 10px 16px;
    border-bottom: 1px solid rgb(244, 244, 244);
   
}
.pd-none {
    .pd-left {
        border-bottom: none;
        padding-bottom: 0;
    }
}
.error-tips {
    position: relative;
    font-size: 14px;
    color: #646566;
    padding: 10px 16px;
    // padding: 0.26667rem 0.42667rem;
    &.tips {
        &::before {
            content: '*';
            position: absolute;
            left: 8px;
            top: 15px;
            color: #ee0a24;
            font-size: 0.37333rem;
        }
    }
    
}
.idcard-demo {
    .case-content {
        padding: 0 20px;
        .case {
            position: relative;
            width: 83px;
            height: 83px;
            margin-right: 5px;
            border-radius: 5px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
            }
            p {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(0, 0, 0, .7);
                span {
                    font-size: 14px;
                    color: #fff;
                }
            }
        }
    }
}
.box {
    &-select {
        border: 1px solid #12cd9f;
        border-radius: 8px;
        padding: 10px 15px;
        margin: 20px 10px 10px;
        color: #323233;
        font-size: 16px;
    }
    &-explain {
        color: #12cd9f;
        padding: 0 10px;
        font-size: 12px;
    }
}
</style>